import { unmountContainer } from '../../utils/react-root.util';
const liveColumnControlHosts = new Set();
const unmountHost = (host) => {
    try {
        unmountContainer(host);
    }
    catch (e) {
    }
    host.remove();
    liveColumnControlHosts.delete(host);
};
export const registerColumnControlHost = (host) => {
    liveColumnControlHosts.add(host);
};
export const sweepColumnControlHosts = (container) => {
    liveColumnControlHosts.forEach(host => {
        if (!host.isConnected || (container && container.contains(host))) {
            unmountHost(host);
        }
    });
};
//# sourceMappingURL=column-control-roots.js.map